import { Outlet } from 'react-router-dom';

// Layout for /g/:gameShortId/playtest-settings/*. With the per-page
// sub-rail moved into the global SecondaryNav, this layout no longer
// needs its own scroll container - the shell's <main> owns scroll, so
// every sub-page shares the same content width regardless of length.
export function PlaytestSettingsPage(): JSX.Element {
  return <Outlet />;
}
